import { ACTION_TYPES } from 'src/constants';

// Accounts
export function setSession(payload) {
  return {
    type: ACTION_TYPES.SET_SESSION,
    payload,
  };
}
